import { HttpInterceptorFn, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { RoutesStatesNamesEnum } from '@uigy/shared/enums/routesStatesNames.enum';
import { LanguageService } from '@uigy/shared/services/language.service';
import { ToasterService } from '@uigy/shared/components/toaster/services/toaster.service';
import { ErrorsDataHelperService } from '@uigy/shared/modules/errors/errors-data-helper.service';
import { HttpHeadersOptions } from '@uigy/graphql.module';

export const restInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toasterService = inject(ToasterService);
  const errorsDataHelperService = inject(ErrorsDataHelperService);
  const languageService = inject(LanguageService); // Injected even if not used directly here

  const token: string = authService.getAuthorizationHeader();
  const ignoreHTTPErrors = req.headers.has(HttpHeadersOptions.ignoreHTTPErrors);
  const queryName = req.headers.get(HttpHeadersOptions.queryName);
  const assetName = req.headers.get(HttpHeadersOptions.assetName);

  let modifiedReq = req;

  // Clean up internal headers
  if (ignoreHTTPErrors) {
    modifiedReq = modifiedReq.clone({ headers: modifiedReq.headers.delete(HttpHeadersOptions.ignoreHTTPErrors) });
  }
  if (queryName) {
    modifiedReq = modifiedReq.clone({ headers: modifiedReq.headers.delete(HttpHeadersOptions.queryName) });
  }
  if (assetName) {
    modifiedReq = modifiedReq.clone({ headers: modifiedReq.headers.delete(HttpHeadersOptions.assetName) });
  }

  // Skip auth header if no token
  if (!token) {
    return next(modifiedReq);
  }

  // Add Authorization header
  modifiedReq = modifiedReq.clone({
    headers: modifiedReq.headers.set('Authorization', token),
  });

  return next(modifiedReq).pipe(
    errorsDataHelperService.handleErrorsPipe(queryName, assetName),
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse && !ignoreHTTPErrors) {
        switch (err.status) {
          case HttpStatusCode.Forbidden:
            router.navigate([RoutesStatesNamesEnum.root, RoutesStatesNamesEnum.unauthorized]);
            break;
          case HttpStatusCode.Unauthorized:
            authService.logout();
            break;
        }
        errorsDataHelperService.showToaster(err?.error);
      }

      return throwError(() => err);
    })
  );
};
